import React, { useState } from 'react';
import { DEFAULT_LOCAL_PATH } from '../../constents';
import { Link } from 'react-router-dom';
import PastAppListPopup from '../Schedular/Appointment/PastAppListPopup';
import { post } from '../Auths/AuthToken';
import UploadDocPopUp from '../Documents/UploadDocPopUp';
import ComPatientComposeText from '../Communication/ComPatientComposeText';
import setUiMessage from '../../Utilities/Tostify';
import ComPatientEmailCompose from '../Communication/ComPatientEmailCompose';
import { useDispatch } from 'react-redux';
import { setSeltSerchPat } from '../../redux/slices/patient/patientSlice';
import {
  setAppPopup,
  setGrpApp,
} from '../../redux/slices/scheduler/appointmentSlice';

function PatientList({ item, altClas, handleReload }) {
  const dispatch = useDispatch();
  const [pastAppListPopup, setPastAppListPopup] = useState(false);
  const [openAddEditPopup, setOpenAddEditPopup] = useState(false);
  const [comTextPopup, setComTextPopup] = useState(false);
  const [comSecureEmailPopup, setComSecureEmailPopup] = useState(false);
  const [comEmailPopup, setComEmailPopup] = useState(false);
  const handlePastAppList = () => {
    setPastAppListPopup(!pastAppListPopup);
  };
  const PatStatusDropDown = ({ patStatusProp, patientId }) => {
    const [patStatus, setPatStatus] = useState(patStatusProp);
    const updatePatientStatus = async (e) => {
      try {
        const response = await post('api/patient/patient/updatePatientStatus', {
          patientStatus: e.target.value,
          patientId: patientId,
        });
        if (response.status === 200) {
          setPatStatus(e.target.value);
          handleReload();
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    };
    const handlePatStatus = (e) => {
      setPatStatus(e.target.value);
      return updatePatientStatus(e);
    };
    return (
      <select className="" value={patStatus} onChange={handlePatStatus}>
        <option value="1">Active</option>
        <option value="0">Inactive</option>
        <option value="2">Deceased</option>
      </select>
    );
  };

  const handleAppOpen = (serchPopupOpen = true, data = null) => {
    if (data) {
      dispatch(
        setSeltSerchPat({
          patId: data?.user_id,
          getPatientType: data?.getPatientType,
          getNewPatientType: data?.getNewPatientType,
          patName: data?.patName,
        })
      );
    } else {
      dispatch(setSeltSerchPat({}));
    }
    dispatch(setGrpApp(false));
    dispatch(setAppPopup(true));
  };

  const handleTextPopup = (user) => {
    if (user?.mobile) {
      setComTextPopup(true);
    } else {
      setUiMessage('inf', 'Mobile number not available.');
    }
  };

  const handleSecureEmailPopup = (user) => {
    if (user?.email) {
      setComSecureEmailPopup(true);
    } else {
      setUiMessage('inf', 'E-mail not available.');
    }
  };

  const handleEmailPopup = (user) => {
    if (user?.email) {
      setComEmailPopup(true);
    } else {
      setUiMessage('inf', 'E-mail not available.');
    }
  };

  return (
    <div className={`patient-list-bdy-rw ${altClas}`}>
      <div className="ptnt-lst-hdr-lbl grw-shrnk pcol-1">
        <Link to={`${DEFAULT_LOCAL_PATH}/patient/counNote/${item?.user_id}`}>
          <span className="">{item?.patient_name}</span>
        </Link>
        <span className="">DOB: {item?.dob}</span>
        <span className="">ID: {item?.chart_number}</span>
      </div>
      <div className="ptnt-lst-hdr-lbl grw-shrnk pcol-2 hide">
        <span className=""></span>
      </div>
      <div className="ptnt-lst-hdr-lbl grw-shrnk pcol-3 hide">
        <span className="">05-25-1992</span>
        <span className="">30 Yrs, Male</span>
      </div>
      <div className="ptnt-lst-hdr-lbl grw-shrnk pcol-6">
        <span className="">{item?.lastvisitdate}</span>
        <span className="">{item?.lastProFullName}</span>
        {item?.signstatus && (
          <span className="">
            Note -<span className="maroon">{item?.signstatus}</span>
          </span>
        )}
      </div>
      <div className="ptnt-lst-hdr-lbl grw-shrnk pcol-7">
        <span className="">{item?.nextAppDate}</span>
        <span className="">{item?.nextapptime}</span>
        <span className="">{item?.nextProFullName}</span>
      </div>
      <div
        className="ptnt-lst-hdr-lbl grw-shrnk pcol-8"
        onClick={handlePastAppList}
      >
        <img width="30%" src="./images/History.png" alt="" />
      </div>
      <div className="ptnt-lst-hdr-lbl grw-shrnk pcol-9">
        <span className="">{item?.insurance_company_name}</span>
        <span className="">Payor Bal: {item?.insbal}</span>
        <span className="">
          Patient Bal: <span className="red">{item?.patbal}</span>
        </span>
      </div>
      <div className="ptnt-lst-hdr-lbl grw-shrnk pcol-10">
        <span className="">
          <Link to={`${DEFAULT_LOCAL_PATH}/patient/counNote/${item?.user_id}`}>
            Go to Chart
          </Link>{' '}
          |
          {item?.active_status === '1' ? (
            <span onClick={() => handleAppOpen(false, item)}>
              <Link to=""> Book Appt.</Link>
            </span>
          ) : (
            <span>Book Appt.</span>
          )}
        </span>
        <span className="">
          <span onClick={() => setOpenAddEditPopup(true)}>
            <Link to="">Upload Doc</Link> |{' '}
          </span>
          <span className="hide" onClick={() => handleSecureEmailPopup(item)}>
            <Link to="">Email notification</Link>
          </span>
          <Link className="hide" to="">
            Take Payment
          </Link>
        </span>
        <span className="">
          <span onClick={() => handleTextPopup(item)}>
            <Link to="">Send Text</Link>
          </span>{' '}
          |{' '}
          <span onClick={() => handleEmailPopup(item)}>
            <Link to="">Send Email</Link>
          </span>
        </span>
      </div>
      <div className="ptnt-lst-hdr-lbl pcol-4">
        <span className="">
          {item?.address} {item?.correspondence_address}
        </span>
        <span className="">{item?.city}</span>
        <span className="">
          {item?.state_name} {item?.zip}
        </span>
      </div>
      <div className="ptnt-lst-hdr-lbl grw-shrnk pcol-5">
        <span className="">M: {item?.mobile}</span>
        <span className="">H: {item?.home_phone}</span>
        <span className="">{item?.email}</span>
      </div>
      <div className="ptnt-lst-hdr-lbl grw-shrnk pcol-11">
        <span className="">
          <PatStatusDropDown
            patStatusProp={item?.active_status}
            patientId={item?.user_id}
          />
        </span>
      </div>
      {pastAppListPopup && (
        <PastAppListPopup
          patientId={item?.user_id}
          setPastAppListPopup={setPastAppListPopup}
        />
      )}
      {openAddEditPopup && (
        <UploadDocPopUp
          close={() => setOpenAddEditPopup(false)}
          patientId={item?.user_id}
          handleReload={() => null}
        />
      )}
      {comTextPopup && (
        <ComPatientComposeText
          close={() => setComTextPopup(false)}
          handleReload={() => {}}
          userPat={item}
        />
      )}
      {comSecureEmailPopup && (
        <ComPatientEmailCompose
          close={() => setComSecureEmailPopup(false)}
          msgType={'0'}
          userPat={item}
        />
      )}
      {comEmailPopup && (
        <ComPatientEmailCompose
          close={() => setComEmailPopup(false)}
          msgType={'1'}
          userPat={item}
        />
      )}
    </div>
  );
}

export default PatientList;
